<!-- Footer -->
<p class="clearfix mb-0 d-flex justify-content-md-between align-items-center">
  <span class="d-block d-md-inline-block mt-25">
    COPYRIGHT &copy; {{ year }},
    <span class="d-none d-sm-inline-block"> All rights Reserved</span>
  </span>
  <span
    class="d-none d-md-flex align-items-center justify-content-end"
    style="flex-grow: 1"
  >
    Powered By
    <a href="https://innovadorsolutions.com" target="_blank" class="ml-1"
      ><img
        style="height: 23px"
        src="assets/images/logo/innovadorsolutions.png"
        alt=""
    /></a>
  </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>
